import { MenuItem } from '@mui/material'
import React from 'react'
import { useLogoutMutation } from '../../../../generated/graphql'

const LogoutButton = (): React.ReactElement => {
    const [doLogout] = useLogoutMutation()
    return (
        <MenuItem
            onClick={(): void => {
                doLogout()
            }}
        >
            Logout
        </MenuItem>
    )
}

export default LogoutButton
